import request from '@/utils/httpRequest'
import qs from 'qs'
export default {
  upload: function (formData, config = {}) {
    return request({
      url: '/file/upload?uploadPath=userdir',
      method: 'post',
      config: config,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  uploadParams: function (formData, params, config = {}) {
    return request({
      url: '/unmfile/cecUnmFile/upload?' + qs.stringify(params),
      method: 'post',
      config: config,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  uploadFileUrl: function (formData, params, config = {}) {
    return request({
      url: '/unmfile/cecUnmFile/uploadFile?' + qs.stringify(params),
      method: 'post',
      config: config,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  updateFileName: function (params) {
    return request({
      url: '/unmfile/cecUnmFile/updateFileName',
      method: 'post',
      params: params
    })
  },
  download: function (params) {
    return request({
      url: '/file/download',
      method: 'get',
      params: params
    })
  },

  uploadFile: function (formData, config = {}) {
    return request({
      url: '/file/uploadFile?uploadPath=userdir',
      method: 'post',
      config: config,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  downloadFile: function (params) {
    return request({
      url: '/file/downloadFile',
      method: 'get',
      params: params
    })
  }
}
